import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Chip,
} from '@mui/material';
import { CloseIcon } from 'assets/icons';

const CustomChipStyled = styled(Chip)(({ theme }) => ({
  opacity: 1,
  backgroundColor: theme.palette.background.default,
  borderRadius: '6px',
  borderColor: theme.palette.primary.light,
  borderWidth: '1px',
  borderStyle: 'solid',
  padding: '7px 5px',
  height: 'auto',
  '& .MuiChip-avatar': {
    width: 30,
    height: 30,
    marginLeft: '3px',
    marginRight: '-3px',
    borderWidth: 1,
    borderStyle: 'solid',
    color: theme.palette.primary.main,
  },
  '& .MuiChip-label': {
    fontSize: '14px',
    fontWeight: 600,
    marginTop: '2px',
  },
  '& .MuiChip-deleteIcon': {
    fontSize: '16px',
    color: theme.palette.primary.main,
    marginLeft: '10px',
    marginRight: 0,
  },
  '& .MuiChip-deleteIcon:hover': {
    color: theme.palette.primary.main,
  },
}));

const CustomChip = (props : any) => (
  <CustomChipStyled deleteIcon={<CloseIcon />} {...props} />
);

export default CustomChip;
